import React, { useEffect, useState } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import TopNavBar from '../Layout/TopNavBar';
import BackNavigation from '../Common/BackNavigation';
import { useLocation, useNavigate } from 'react-router-dom';
import { isEmpty } from 'lodash';
import upload from "../../assets/upload.svg";
import MinusAdjustment from "../../assets/max-adjustment.svg";
import addplus from "../../assets/addplusicon.png";
import { title } from 'process';
import { showError, showSuccess } from '../utills/sweetAlert';
import { callApi } from '../utills/api';
import { Hourglass } from 'react-loader-spinner';

type Row = {
    attachment: any[];  // Updated to `any[]` if you want attachment to be an array that can hold any type
    updateStatus: boolean;
    errorMessage?: string;
};

const AddGallery: React.FC = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { masterId } = location.state || {};
    const [rows, setRows] = useState<Row[]>([]);
    const [state, setState] = useState({
        title: ""
    });
    const [loading, setLoading] = useState(false);
    const [removedRowIds, setRemovedRowIds] = useState<number[]>([]);

    useEffect(() => {
        console.log("rows--->", rows);
    }, [rows]);

    useEffect(() => {
        if (masterId) {
            getEditSelect();
        }
    }, []);

    const getEditSelect = () => {
        let req = {
            id: masterId,
        };
        callApi("POST", "gallerySingleSelect.php", req)
            .then((res) => res.data)
            .then((response) => {
                if (response && response.data) {
                    console.log("response--->image", response.data);
                    setRows(response.data);
                    setState((prevState) => ({
                        ...prevState,
                        title: response.data[0].title,
                    }));
                } else {
                    console.warn("No image data found in the response");
                    setRows([]); // Set an empty array to avoid undefined issues
                }
                console.log("rows--->", rows);
            })
            .catch((err: any) => {
                console.error(
                    "API call error:",
                    err.response ? err.response.data.error : err.message
                );
                showError(
                    "Failed",
                    err.response ? err.response.data.error : err.message
                );
            });
    }

    const validateFile = (file: File) => {
        const validTypes = ["image/jpeg", "image/png", "image/svg+xml"];
        return validTypes.includes(file.type);
    };

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>, rowIndex: number) => {
        const file = event.target.files?.[0];

        if (file && validateFile(file)) {

            convertFileToBase64(file, rowIndex);
            updateRow(rowIndex, "errorMessage", ""); 
        } else {
            console.log("3333");
            updateRow(
                rowIndex,
                "errorMessage",
                "Unsupported file format. Please upload JPEG, PNG, or SVG."
            );
        }
    };

    useEffect(() => {
        console.log("Updated Rows:", rows);
    }, [rows]);
    
    const convertFileToBase64 = (file: File, rowIndex: number) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = () => {
            const base64data = reader.result as string;
            updateRow(rowIndex, "attachment", [
                {
                    imageData: base64data,
                    imageType: file.type.replace("image/", ""),
                    updateStatus: true,
                    errorMessage:"",
                }
            ]);
        };
        reader.onerror = () => {
            updateRow(rowIndex, "errorMessage", "Error converting file to Base64.");
        };
    };

    const handleDrop = (event: React.DragEvent<HTMLDivElement>, rowIndex: number) => {
        event.preventDefault();
        const file = event.dataTransfer.files[0];
        if (file && validateFile(file)) {
            convertFileToBase64(file, rowIndex);
        }
    };

    const handleDragOver = (event: React.DragEvent<HTMLDivElement>) => {
        event.preventDefault();
    };

    // const updateRow = (index: number, field: keyof Row, value: any) => {
    //     const updatedRows = [...rows];
    //     if (field === 'attachment' && Array.isArray(value)) {
    //         updatedRows[index][field] = value; // Ensures `value` is an array for 'attachment'
    //     } else if (field === 'updateStatus' && typeof value === 'boolean') {
    //         updatedRows[index][field] = value; // Ensures `value` is a boolean for 'updateStatus'
    //     }
    //     setRows(updatedRows);
    // };
    const updateRow = (index: number, field: keyof Row, value: any) => {
        const updatedRows = [...rows];
        const rowToUpdate = updatedRows[index];
    
        // Handle `attachment` updates
        if (field === "attachment" && Array.isArray(value)) {
            rowToUpdate[field] = value;
        }
        // Handle `updateStatus` updates
        else if (field === "updateStatus" && typeof value === "boolean") {
            rowToUpdate[field] = value;
        }
        // Handle `errorMessage` updates
        else if (field === "errorMessage" && typeof value === "string") {
            rowToUpdate[field] = value;
        } else {
            console.warn(`Field ${field} is not handled or value type is incorrect.`);
        }
    
        setRows(updatedRows);
    };
    

    const handleAddRow = () => {
        setRows([
            ...rows,
            {
                attachment: [{
                    url: "",
                    imageType: "",
                    updateStatus: true,
                    errorMessage:"",
                }],
                updateStatus: true,
            }
        ]);
    }

    const handleRemoveRow = (index: number, id: any) => {
        // setRemovedRowIds((prevRemovedRowIds) => [...prevRemovedRowIds, id]);
        const updatedRows = rows.filter((_, rowIndex) => rowIndex !== index);
        setRows(updatedRows);
    };


    useEffect(() => {
        console.log("removedRowIds--->", removedRowIds);

    }, [removedRowIds]);


    const SiteOnchange = (event: any) => {
        const { name, value } = event.target;
        const sanitizedValue = value.replace(/ {2,}/g, ' ');

        setState((prevState) => ({
            ...prevState,
            [name]: sanitizedValue,
        }));
    }

    const handleSubmit = (event: any) => {
        console.log("rows--->", rows);

        const form = event.target.form;
        if (form.checkValidity() === false) {
            console.log("Form validation failed.");
            return;
        }
        event.preventDefault();
        const trimmedtitle = state.title.trim();

        if (trimmedtitle) {
            const payload = {
                id: masterId,
                title: trimmedtitle,
                deletedIds: removedRowIds,
                attachment: rows.flatMap(row => row.attachment),
            }
            let apiName;
            if (!isEmpty(masterId)) {
                apiName = 'galleryUpdate.php'
                setLoading(true);
            } else {
                apiName = 'galleryInsert.php'
                setLoading(true);
            }
            callApi("POST", apiName, payload)
                .then((res) => res.data)
                .then((response) => {
                    if (response) {
                        setLoading(false);
                        showSuccess("Success!", "  Successfully!");
                        if (window.history.length === 0) return navigate('/gallery');
                        navigate(-1);
                    }
                })
                .catch((err: any) => {
                    setLoading(false);

                    console.error(
                        "API call error:",
                        err.response ? err.response.data.error : err.message
                    );
                    showError(
                        "Failed",
                        err.response ? err.response.data.error : err.message
                    );
                });
        } else {
            showError(
                "Failed", "Empty Space Not Allowed");
            setState((prevState) => ({
                ...prevState,
                title: "",
            }));
        }

    };
    const handleImageClose = (index: number, fileIndex: number, imageId: any) => {
        setRemovedRowIds((prevRemovedRowIds) => [...prevRemovedRowIds, imageId]);
        setRows((prevRows) =>
            prevRows.map((row, rowIndex) =>
                rowIndex === index
                    ? {
                        ...row,
                        attachment: row.attachment.filter((_, fileIdx) => fileIdx !== fileIndex),
                    }
                    : row
            )
        );
    };
    return (
        <>
            <div className="mobile_nav_bar">
                <TopNavBar />
            </div>
            <div className='mblcontent'>
                <form>
                    <Row className='webview'>
                        <div className="category-header">
                            <Col lg="9" md="9">
                                <BackNavigation />
                                <h3 className="category-title mt-2">
                                    {masterId ? "Edit Page" : "Add Photos"}
                                </h3>
                            </Col>
                        </div>
                    </Row>
                    <div className="element-container">

                        <Row>
                            <Col md="4" className="flexalignitemcenter mt-4 mb-4">
                                <input
                                    type="text"
                                    className="form-control  bg"
                                    placeholder="Enter Image Title"
                                    minLength={2}
                                    maxLength={400}
                                    onChange={SiteOnchange}
                                    name="title"
                                    required
                                    value={state.title}
                                />
                            </Col>
                        </Row>

                        {rows.map((row: any, index) => (
                            <React.Fragment key={index}>
                                <Row>
                                    {row.attachment && row.attachment.map((attachment: any, fileIndex: number) => (

                                        <><Col md="5" lg="4" className='mb-3 flexalignitemcenter'>
                                            {isEmpty(attachment.url) && (
                                                <div
                                                    className="file-upload"
                                                    onDrop={(e) => handleDrop(e, index)}
                                                    onDragOver={handleDragOver}
                                                >
                                                    <input
                                                        type="file"
                                                        id={`file-input-${index}`}
                                                        style={{ display: 'none' }}
                                                        onChange={(e) => handleFileChange(e, index)} />
                                                    <div
                                                        className="upload-icon"
                                                        onClick={() => document.getElementById(`file-input-${index}`)?.click()}
                                                    >
                                                        <img src={upload} alt="Upload Icon" />
                                                    </div>
                                                    <div className="drag-drop-area">
                                                        <p>
                                                            Drag and Drop file here or{' '}
                                                            <label htmlFor={`file-input-${index}`} style={{ cursor: 'pointer' }}>
                                                                Choose file
                                                            </label>
                                                        </p>
                                                        <p className="file-info">Supported formats: JPEG, PNG, SVG.</p>
                                                        <p style={{ color: "red" }}>Minimum upload size (484px X 530px)</p>

                                                        {attachment.imageType && (
                                                            <div className="file-info">
                                                                {attachment.imageType} file added
                                                            </div>
                                                        )}

                                                        {row.errorMessage && (
                                                            <div className="error-message" style={{ color: "red" }}>
                                                                {row.errorMessage}
                                                            </div>
                                                        )}

                                                    </div>
                                                </div>
                                            )}
                                            {attachment.url && (
                                                <div
                                                    style={{
                                                        position: "relative",
                                                        display: "inline-block",
                                                    }}
                                                >
                                                    <img
                                                        src={attachment.url}
                                                        alt="Uploaded Icon"
                                                        style={{ width: "100px" }} />
                                                    <span
                                                        style={{
                                                            cursor: "pointer",
                                                            fontSize: "18px",
                                                            backgroundColor: "white",
                                                            borderRadius: "50%",
                                                            padding: "2px 6px",
                                                            boxShadow: "0 0 5px rgba(0,0,0,0.3)",
                                                        }}
                                                        onClick={() => handleImageClose(index, fileIndex, attachment.id)}
                                                    >
                                                        &times;
                                                    </span>
                                                </div>
                                            )}
                                        </Col>

                                            <Col md="1" lg="1" className='flexalignitemcenter'>
                                                {isEmpty(attachment.url) && (
                                                    <img
                                                        style={{
                                                            width: "28px",
                                                            cursor: "pointer",
                                                            marginLeft: "5px",
                                                        }}
                                                        src={MinusAdjustment}
                                                        alt="Remove row"
                                                        onClick={() => handleRemoveRow(index, attachment.id)} />
                                                )}
                                            </Col></>

                                    ))}

                                </Row>
                            </React.Fragment>
                        ))}

                        <Col md="3" lg="3" className="flexalignitemcenter">
                            {/* <img
                            style={{ width: "28px", cursor: "pointer" }}
                            src={addplus}
                            alt="Add row"
                            onClick={handleAddRow}
                        /> */}

                            <div className="mt-2">
                                <div
                                    className="more-btn d-flex align-items-center justify-content-center mb-3 "
                                    style={{
                                        cursor: "pointer"
                                    }}
                                    onClick={handleAddRow}
                                >
                                    <img
                                        style={{ width: "28px", cursor: "pointer" }}
                                        src={addplus}
                                        alt="Add Image"
                                    />
                                    {" "}
                                    Add Image
                                </div>
                            </div>
                        </Col>

                        <div className='flexend'>
                            <button className="save-btn" type={!isEmpty(masterId) ? 'button' : 'submit'} onClick={handleSubmit}>
                                {!isEmpty(masterId) ? 'Update' : 'Save'}
                            </button>
                        </div>
                    </div>
                </form>
            </div>

            {loading && (
                <div className="loader-overlay">
                    <div className="loader-container">
                        <Hourglass visible={true} height={50} width={50} />
                    </div>
                </div>
            )}
        </>
    );
};
export default AddGallery;
